import {createSelector} from 'reselect';
import {getStart} from '../selectors/selectors';

export default createSelector(
  [getStart],
  start => start.order?.billingAddress?.countryCode || start.customer?.location,
);
